import {IFarmInputQuote, IQuoteMessage} from 'constants/interfaces';
import IconButton from '@material-ui/core/IconButton';
import {
  Avatar,
  Box,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import SendIcon from '@material-ui/icons/Send';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import {Skeleton} from '@material-ui/lab';
import {TextMessage} from 'screens/Dashboard/Invoices/InvoiceChat/TextMessage';
import './QuoteChat.scss';

export function QuoteChat(props: {
  isLoading: boolean;
  isRefreshing: boolean;
  myProfilePicture?: string;
  quote?: IFarmInputQuote;
  messages: IQuoteMessage[];
  onMessageSend: (text: string) => any;
  readonly?: boolean;
  header?: boolean;
}) {
  const {
    isLoading,
    isRefreshing,
    myProfilePicture,
    quote,
    messages,
    onMessageSend,
    header = true,
  } = props;
  const [messageText, setMessageText] = useState<string>('');
  const [bottomOfMessagesRef, setBottomOfMessagesRef] = useState<any>();
  const sendMessage = () => {
    if (props.readonly) return;
    const trimmedMessage = messageText.trim();
    if (!trimmedMessage) return;
    onMessageSend(trimmedMessage);
    setMessageText('');
  };

  const handleTextChange = (event: any) => {
    // ignore when you press enter. Used as a trigger to send message
    if (event.target.value === '\n') return;
    setMessageText(event.target.value);
  };

  const scrollToBottom = () => {
    bottomOfMessagesRef?.scrollIntoView({behavior: 'auto'});
  };

  useEffect(scrollToBottom, [isLoading, messages]);

  return (
    <Box className="quote-chat-container-2">
      {header && (
        <AppBar className="title-bar" elevation={0} variant="outlined">
          <Toolbar>
            <Avatar src={quote?.farmer?.image} className={'avatar'} />
            <Box className="title">
              <Typography variant="body2" color="textPrimary">
                {quote?.farmer?.name} {quote?.farmer?.surname}
              </Typography>
              {quote?.farmer?.farm?.name && (
                <Typography variant="caption" color="textPrimary">
                  {quote?.farmer?.farm?.name}
                </Typography>
              )}
            </Box>
          </Toolbar>
        </AppBar>
      )}
      <Box className="order-chat-message-container">
        {isLoading &&
          [1, 2, 3, 4, 5].map((index) => (
            <Box key={index} mb={2}>
              <Skeleton variant="rect" height={100} style={{borderRadius: 8}} />
            </Box>
          ))}
        {!isLoading &&
          messages.map((message, index) =>
            message.messageType === 'TEXT' ? (
              <TextMessage
                key={message.id}
                myProfileImage={myProfilePicture}
                farmerProfileImage={quote?.farmer?.image}
                isSent={message.senderType === 'SUPPLIER'}
                date={message.date}
                messageText={message.message}
              />
            ) : null,
          )}
        <div ref={(element) => setBottomOfMessagesRef(element)} />
      </Box>
      <AppBar className="response-bar" elevation={0} variant="outlined">
        <Toolbar>
          <Avatar src={myProfilePicture} className={'avatar'} />
          <TextField
            className="text-input"
            id="outlined-basic"
            variant="outlined"
            size="small"
            multiline
            value={messageText}
            onChange={handleTextChange}
            onKeyDown={(e) => {
              // send message when you press enter
              e.keyCode === 13 && sendMessage();
            }}
            disabled={props.readonly}
          />
          {isRefreshing ? (
            <CircularProgress color={'primary'} size={30} thickness={6} />
          ) : (
            <IconButton
              className="send-button"
              size="small"
              onClick={sendMessage}
              disabled={props.readonly}
            >
              <SendIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
